<template>
  <div></div>
</template>

<script>
import { quickView } from '@/api/apply'

export default {
  name: 'QuickView',
  mounted () {
    this.loadApply()
  },
  methods: {
    loadApply () {
      const applyUuid = this.$route.query.uuid
      if (!applyUuid) {
        this.$router.push('/')
      }
      quickView({
        applyUuid
      }).then(res => {
        const apply = res.data
        if (apply) {
          this.$store.dispatch('setQuickQueryApplyId', res.data.id)
          this.$router.push('/applyList')
        } else {
          this.$router.push('/')
        }
      })
    }
  }
}
</script>
